import type { SVGProps } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
	<svg width={props.width || '1em'} height={props.height || '1em'} fill="none" {...props} viewBox="0 0 73 12">
		<path fill={props.color || 'var(--icon)'} d="M1 4.774a1 1 0 1 0 0 2v-2Zm72 1L63 0v11.547l10-5.774Zm-72 0v1h63v-2H1v1Z" />
	</svg>
);
export default SvgComponent;
